/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/podcast'
export default icon
